import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faFacebook,
    faInstagram,
    faLinkedinIn,
    faSlack,
    faTwitter,
    faXTwitter,
    faYoutube
} from "@fortawesome/free-brands-svg-icons";
import {
    faBell,
    faBookmark as faBookmarkRegular,
    faCalendar,
    faCircleLeft,
    faCircle as faCircleRegular,
    faCircleRight,
    faClock,
    faCopy as faCopyRegular,
    faEnvelope as faEnvelopeAlt,
    faEye as faEyeAlt,
    faFileLines as faFileLinesRegular,
    faGem,
    faIdBadge,
    faMap,
    faMessage as faMessageRegular,
    faPaperPlane,
    faRectangleList,
    faSquareCaretDown as faSquareCaretOutline,
    faStarHalfStroke,
    faStar as faStarOutline,
    faThumbsUp,
    faTrashCan
} from "@fortawesome/free-regular-svg-icons";
import {
    faTrashCan as altTrashCan,
    faAlignLeft,
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faArrowDownShortWide,
    faArrowDownWideShort,
    faArrowLeft,
    faArrowRightToBracket,
    faArrowsLeftRightToLine,
    faArrowsSpin,
    faArrowTurnUp,
    faArrowUpFromBracket,
    faArrowUpRightFromSquare,
    faArrowUpShortWide,
    faArrowUpWideShort,
    faAt,
    faBars,
    faBell as faBellFilled,
    faBookmark,
    faBoxesStacked,
    faBuilding,
    faBullhorn,
    faCalendarDays,
    faCaretDown,
    faCaretUp,
    faCheck,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faCircleCheck,
    faCircleChevronDown,
    faCircleExclamation,
    faCircleInfo,
    faCircleNotch,
    faCirclePlus,
    faCircleQuestion,
    faCircleXmark,
    faClipboard,
    faClipboardList,
    faCloudArrowUp,
    faCommentDollar,
    faComments,
    faCopy,
    faCrosshairs,
    faCrown,
    faDownLeftAndUpRightToCenter,
    faDownload,
    faEllipsis,
    faEnvelope,
    faExclamation,
    faEye,
    faEyeSlash,
    faFileCirclePlus,
    faFileLines,
    faFilePen,
    faFilter,
    faFilterCircleXmark,
    faFlagCheckered,
    faGear,
    faGears,
    faGlobe,
    faGripVertical,
    faHand,
    faHashtag,
    faHouseTsunami,
    faInfo,
    faLink,
    faList,
    faListCheck,
    faLocationDot,
    faLock,
    faMagnifyingGlass,
    faMaximize,
    faMessage,
    faMinimize,
    faMinus,
    faPen,
    faPencil,
    faPenToSquare,
    faPeopleArrows,
    faPeopleGroup,
    faPhone,
    faPlay,
    faPlus,
    faQuestion,
    faRightFromBracket,
    faRocket,
    faRotateLeft,
    faSort,
    faSortDown,
    faSortUp,
    faSpinner,
    faSquareCaretDown,
    faStar,
    faStop,
    faTag,
    faTriangleExclamation,
    faTrophy,
    faUpload,
    faUpRightAndDownLeftFromCenter,
    faUpRightFromSquare,
    faUser,
    faUserAstronaut,
    faUserGear,
    faUserLock,
    faUserPen,
    faUsers,
    faUsersViewfinder,
    faXmark
} from "@fortawesome/free-solid-svg-icons";
import {
    FontAwesomeIcon,
    FontAwesomeLayers
} from "@fortawesome/vue-fontawesome";

library.add(
    altTrashCan,
    faAlignLeft,
    faAngleLeft,
    faAngleDown,
    faAngleRight,
    faArrowDownShortWide,
    faArrowDownWideShort,
    faArrowRightToBracket,
    faArrowLeft,
    faArrowsLeftRightToLine,
    faArrowsSpin,
    faArrowTurnUp,
    faArrowUpFromBracket,
    faArrowUpRightFromSquare,
    faArrowUpShortWide,
    faArrowUpWideShort,
    faAt,
    faIdBadge,
    faBars,
    faBell,
    faBellFilled,
    faBookmark,
    faBookmarkRegular,
    faBoxesStacked,
    faBuilding,
    faBullhorn,
    faCalendar,
    faCalendarDays,
    faCaretDown,
    faCaretUp,
    faCheck,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCloudArrowUp,
    faCircle,
    faCircleCheck,
    faCircleChevronDown,
    faCircleExclamation,
    faCircleInfo,
    faCircleLeft,
    faCircleNotch,
    faCirclePlus,
    faCircleQuestion,
    faCircleRight,
    faCircleRegular,
    faCircleXmark,
    faClipboard,
    faClipboardList,
    faClock,
    faCommentDollar,
    faComments,
    faCopy,
    faCopyRegular,
    faCrosshairs,
    faCrown,
    faDownLeftAndUpRightToCenter,
    faDownload,
    faEnvelope,
    faEllipsis,
    faExclamation,
    faEye,
    faEyeAlt,
    faEyeSlash,
    faFacebook,
    faFileCirclePlus,
    faFileLines,
    faFileLinesRegular,
    faFilePen,
    faFilterCircleXmark,
    faFlagCheckered,
    faEnvelope,
    faEnvelopeAlt,
    faGear,
    faGears,
    faGem,
    faGlobe,
    faGripVertical,
    faHand,
    faHashtag,
    faHouseTsunami,
    faIdBadge,
    faInstagram,
    faLink,
    faLinkedinIn,
    faList,
    faListCheck,
    faLocationDot,
    faLock,
    faMagnifyingGlass,
    faMap,
    faMaximize,
    faMessage,
    faMessageRegular,
    faMinus,
    faMinimize,
    faPaperPlane,
    faPen,
    faPencil,
    faPenToSquare,
    faPeopleArrows,
    faPeopleGroup,
    faPhone,
    faPlay,
    faPlus,
    faQuestion,
    faRocket,
    faRectangleList,
    faRightFromBracket,
    faRotateLeft,
    faSlack,
    faSort,
    faSortDown,
    faSortUp,
    faSpinner,
    faSquareCaretDown,
    faSquareCaretOutline,
    faStar,
    faStarHalfStroke,
    faStarOutline,
    faStop,
    faTag,
    faThumbsUp,
    faTrashCan,
    faTriangleExclamation,
    faTrophy,
    faTwitter,
    faUpload,
    faUpRightAndDownLeftFromCenter,
    faUpRightFromSquare,
    faUser,
    faUsers,
    faUserAstronaut,
    faUserGear,
    faUserLock,
    faUserPen,
    faUsersViewfinder,
    faXmark,
    faXTwitter,
    faYoutube,
    faInfo,
    faFilter
);

export const APP_ICONS = FontAwesomeIcon;
export const ICON_LAYERS = FontAwesomeLayers;
